import React, { useState } from 'react';
import clsx from 'clsx';
import style from './style.module.scss';
import MajorViewSlider from '../../view/slider';
import Banner from '../../../../../components/banner';
import useStore from '../../../../../hooks/useStore';

const MajorSportsTypeWrapper = ({ page, sportsView, majorSelected, selectedList, setSelectedGame, toggleEffect }) => {
  const [toggles, setToggles] = useState({
    soccer: true,
    baseball: true,
    basketball: true,
    volleyball: true,
    hockey: true,
    football: true,
  });
  const { bannerStore } = useStore();

  const onClickToggle = (type) => {
    setToggles({
      ...toggles,
      [type]: !toggles[type],
    });
    toggleEffect();
  };

  return (
    <div className={clsx(style.sportTypeWrapper, page === 'home' ? style.table_hide_content : '')}>
      {/* 축구 */}
      {sportsView.soccer.length > 0 && (
        <div className={style.soccerBox}>
          <div className={clsx(style.game_type, style.soccer)}>
            <h3 className={style.tit}>축구 - Soccer</h3>
            <button
              className={clsx(style.btn_view, !toggles.soccer && style.close)}
              onClick={() => onClickToggle('soccer')}
            >
              닫기
            </button>
          </div>
          {toggles.soccer && (
            <>
              {selectedList.length === 0 ? <Banner paddingTop='0' /> : null}
              <MajorViewSlider
                list={sportsView.soccer}
                majorSelected={majorSelected}
                setSelectedGame={setSelectedGame}
                viewType={'SPORTS_TYPE_VIEW'}
              />
            </>
          )}
        </div>
      )}

      {/* 야구 */}
      {sportsView.baseball.length > 0 && (
        <div className={style.soccerBox}>
          <div className={clsx(style.game_type, style.baseball)}>
            <h3 className={style.tit}>야구 - Baseball</h3>
            <button
              className={clsx(style.btn_view, !toggles.baseball && style.close)}
              onClick={() => onClickToggle('baseball')}
            >
              닫기
            </button>
          </div>

          {toggles.baseball && (
            <MajorViewSlider
              list={sportsView.baseball}
              majorSelected={majorSelected}
              setSelectedGame={setSelectedGame}
              viewType={'SPORTS_TYPE_VIEW'}
            />
          )}
        </div>
      )}

      {/* 농구 */}
      {sportsView.basketball.length > 0 && (
        <div className={style.soccerBox}>
          <div className={clsx(style.game_type, style.basketball)}>
            <h3 className={style.tit}>농구 - Basketball</h3>
            <button
              className={clsx(style.btn_view, !toggles.basketball && style.close)}
              onClick={() => onClickToggle('basketball')}
            >
              닫기
            </button>
          </div>

          {toggles.basketball && (
            <MajorViewSlider
              list={sportsView.basketball}
              majorSelected={majorSelected}
              setSelectedGame={setSelectedGame}
              viewType={'SPORTS_TYPE_VIEW'}
            />
          )}
        </div>
      )}

      {/* 배구 */}
      {sportsView.volleyball.length > 0 && (
        <div className={style.soccerBox}>
          <div className={clsx(style.game_type, style.volleyball)}>
            <h3 className={style.tit}>배구 - Volleyball</h3>
            <button
              className={clsx(style.btn_view, !toggles.volleyball && style.close)}
              onClick={() => onClickToggle('volleyball')}
            >
              닫기
            </button>
          </div>

          {toggles.volleyball && (
            <MajorViewSlider
              list={sportsView.volleyball}
              majorSelected={majorSelected}
              setSelectedGame={setSelectedGame}
              viewType={'SPORTS_TYPE_VIEW'}
            />
          )}
        </div>
      )}

      {/* 아이스하키 */}
      {sportsView.hockey.length > 0 && (
        <div className={style.soccerBox}>
          <div className={clsx(style.game_type, style.icehockey)}>
            <h3 className={style.tit}>아이스하키 - Icehockey</h3>
            <button
              className={clsx(style.btn_view, !toggles.hockey && style.close)}
              onClick={() => onClickToggle('hockey')}
            >
              닫기
            </button>
          </div>

          {toggles.hockey && (
            <MajorViewSlider
              list={sportsView.hockey}
              majorSelected={majorSelected}
              setSelectedGame={setSelectedGame}
              viewType={'SPORTS_TYPE_VIEW'}
            />
          )}
        </div>
      )}

      {/* 미식축구 */}
      {/* <div className={style.soccerBox}>
        <div className={clsx(style.game_type, style.football)}>
          <h3 className={style.tit}>미식축구 - Football</h3>
          <button
            className={clsx(style.btn_view, !toggles.hockey && style.close)}
            onClick={() => onClickToggle('football')}
          >
            닫기
          </button>
        </div>

        {toggles.football && (
          <MajorViewSlider
            list={sportsView.football}
            majorSelected={majorSelected}
            setSelectedGame={setSelectedGame}
          />
        )}
      </div> */}
    </div>
  );
};

export default MajorSportsTypeWrapper;
